<template>
  <div class="tile-event-group-container" :class="{'past-event': all_is_past()}">
    
    <div class="tile-event-group">
      <div class="tile-event-group-group">
        <div style="display: grid; grid-template-columns: 1fr max-content max-content; cursor: pointer;" class="ml-1" @click="open">
          <div>
            {{events[0].cached_start_time | format_time}} - {{get_end_time(events[0].cached_start_time, last_end_time())}}
          </div>
          <div>
            <k-btn v-if="$is_admin()" size="s" no-margin icon icon-name="ondemand_video" :color="is_monitor ? 'success' : 'white'" @click.stop="add_to_monitor"></k-btn>
          </div>
          <div>
            <k-btn no-margin v-tooltip="'Add schedule'" flat size="xs" @click.stop="open_schedule"><k-icon small color="accent">add</k-icon></k-btn>
          </div>
        </div>
        <div class="ma-0 pa-0">
          <template v-if="event_group.channel_id">
            <channel :channel="event_group.channel_id" :event="events[0]" type="source"></channel>
          </template>
        </div>
        <div v-if="large_mode">
          <div style="width: 60%;" class="mt-2 mb-2">
            <monitor-video :closable="false" color="grey" hide-footer :urls="[{'title':'preview','url': event_group_monitor.url}]" v-if="event_group_monitor.url">
              <template v-slot:title>Source</template>
            </monitor-video>
          </div>
        </div>
      </div>

      <div class="tile-event-group-events">
        <div v-for="(event, i) in filtered_events" :key="event.uuid" class="mb-1">
          <tile-events :event="event" :linked-events="linked_events(event)" :group-events="events" @changed="$emit('changed')"></tile-events>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import EventModel from '@/models/event.js'
import ChannelModel from '@/models/channel.js';
import InstanceModel from '@/models/instance.js';

import InstanceInfo from './Instance.vue';

import MonitorView from '@/components/monitor/Item.vue'
import MonitorVideo from '@/components/MonitorVideo.vue';

import Channel from './Channel'
import InstanceStats from '../instances/Stats'

import datelib from '@/lib/date.js';

import Vue from 'vue';
import TileEvents from './TileEvents';


export default {
  props: ["events"],
  data () {
    return {
      timestamp: 0,
      updater: undefined,
      large_mode: false,
      is_monitor: false
    }
  },
 filters: {
    ...datelib
  },
  components: {
    MonitorView,
    MonitorVideo,
    Channel,
    InstanceStats,
    InstanceInfo,
    TileEvents
  },
  mounted () {
    var self = this;
    this.timestamp = self.$store.state.timestamp;
    this.timestamp_update();

    this.updater = setInterval(function() {
      self.timestamp = self.$store.state.timestamp;
      self.timestamp_update();
    },1000);

  },
  methods: {
    get_end_time(start_time, end_time) {
      var start_date = datelib.format_date(start_time);
      var end_date = datelib.format_date(end_time);
      if (start_date != end_date) {
        return datelib.format_time(end_time) + " (" + datelib.format_date(end_time) + ")";
;
      }
      return datelib.format_time(end_time);
    },
    timestamp_update() {
      var channel = EventModel.input_channel(this.events[0]);
      var alternative = EventModel.alternative(this.events[0]);
      this.is_monitor = ChannelModel.is_monitor(channel, alternative);
    },
    event_title(event) {
      return EventModel.title(event);
    },
    event_subtitle(event) {
      return EventModel.subtitle(event);
    },
    last_end_time() {
      var ret = 0;
      _.each(this.events, function(event) {
        if (event.cached_end_time > ret) ret = event.cached_end_time;
      });
      return ret;
    },
    is_past(event) {
      return EventModel.is_past(event, this.timestamp);
    },
    is_current(event) {
      return EventModel.is_current(event, this.timestamp);
    },
    all_is_past() {
      var self = this;
      var ret = _.find(this.events, function(event) {
        if (self.is_past(event)) return false;
        return true;
      });
      if (typeof(ret) == "undefined") return true;
      return false;
    },
    get_state(data, type) {
      var i = data.instance;
      if (typeof(i) != "undefined") {
        var s = i[type];
        if (typeof(s) != "undefined") {
          return s;
        }
      }
      return;
    },
    get_source_state(data) {
      return this.get_state(data, "source");
    },
    open () {
      this.$router.push("/dashboard/event/"+this.events[0].uuid)
    },
    open_schedule () {
      this.$router.push("/dashboard/event/"+this.events[0].uuid+"?tab=schedule")
    },
    linked_events(event) {
      return _.filter(this.events, (e) => {
        var linked = _.get(e, ["system_meta", "linked_event"], undefined);
        if (linked == event.uuid) return true;
        return false;
      });
    },
    add_to_monitor() {
      var channel = EventModel.input_channel(this.events[0]);
      var alternative = EventModel.alternative(this.events[0]);
      this.is_monitor = ChannelModel.toggle_monitor(channel, alternative);
    }
  },
  computed: {
    filtered_events () {
      return _.filter(this.events, (event) => {
        return event.event_group.uuid == this.events[0].event_group.uuid;
      });
    },
    title () {
      return EventModel.title(this.events[0]);
    },
    subtitle () {
      return EventModel.subtitle(this.events[0]);
    },
    instances() {
      return this.$store.state.instances;
    },
    source_instance() {
      var eg = this.event_group;
      var channel = ChannelModel.channel_by_id(eg.channel_id);
      if (typeof(channel) != "undefined" && channel != null) {
        return ChannelModel.instance(channel, {});
      }
      return undefined;
    },
    event_group() {
      return this.events[0].event_group;
    },
    event_group_monitor() {
      var eg = this.event_group;
      var alternative = _.get(eg, "system_meta.alternative", "");
      var channel = ChannelModel.channel_by_id(eg.channel_id);
      if (typeof(channel) != "undefined") {
        var id = channel.uuid;
        var data = ChannelModel.status(channel, alternative);
        if (typeof(data) != "undefined") {
          var headend = this.instances[data.headend_instance];
          var state = (this.get_source_state(data)||{}).state;
          return {key: id, state: state, channel: channel, alternative: alternative, url: InstanceModel.headend_preview_url(headend, id, alternative)};
        }
      }
      return {};
    }
  }
}
</script>
<style scoped>
.cut-text { 
    display: inline-block;
    max-width: 98%;
    white-space: nowrap;
    overflow: hidden !important;
    text-overflow: ellipsis;
}

.past-event {
  opacity: 0.4;
}

</style>

<style>

.tile-event-group-container {
  container-type: inline-size;
  container-name: event-group;
  border-radius: 6px; 
  padding: var(--ks-padding-1); 
  margin-bottom: var(--ks-margin-2);
  background: var(--ks-background-color);
}

.tile-event-group {
  display: grid; 
  grid-template-columns: 4fr 10fr;
  grid-gap: 5px;
  grid-template-areas: "group events";
}
.tile-event-group .tile-event-group-arrow {
  grid-area: arrow;
}
.tile-event-group .tile-event-group-group {
  grid-area: group;
}
.tile-event-group .tile-event-group-events {
  grid-area: events;
}



@container event-group (max-width: 768px) {
  .tile-event-group {
    grid-template-columns: 1fr;
    grid-template-areas: "group" 
                         "events";
  }
  .tile-event-group .tile-event-group-events {
    width: 100%;
    overflow: hidden;
  }
  .tile-event-group .tile-event-group-arrow {
    display: none;
  }
}

</style>